import { createFileRoute } from '@tanstack/react-router';
import { influencerStaticData } from '../../../influencer';

export const Route = createFileRoute(
  '/_private-routes/influencer/$id/$socialMediaAccountId/youtube_compare_feed_videos'
)({
  staticData: influencerStaticData
});
